'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../../buttons/ClearButton/ClearButton.js');
var reactIntl = require('react-intl');
require('../../buttons/SecondaryButton/SecondaryButton.js');
require('../../buttons/AddAttachmentsButton/AddAttachmentsButton.js');
require('../../buttons/BlueTextButton/BlueTextButton.js');
require('../../buttons/BackButton/BackButton.js');
require('../../buttons/BorderlessButton/BorderlessButton.js');
require('../../buttons/ButtonAndStatus/ButtonAndStatus.js');
require('../../buttons/ButtonGroup/ButtonGroup.js');
var DialogPrimaryButton = require('../../buttons/DialogPrimaryButton/DialogPrimaryButton.js');
var DialogSecondaryButton = require('../../buttons/DialogSecondaryButton/DialogSecondaryButton.js');
require('../../buttons/DialogWarningButton/DialogWarningButton.js');
require('../../buttons/FormButton/FormButton.js');
require('../../buttons/IconButtonWithDropDown/IconButtonWithDropDown.js');
require('../../buttons/PillButton/PillButton.js');
require('../../buttons/PrimaryButton/PrimaryButton.js');
require('../../buttons/TwoToneButton/TwoToneButton.js');
require('../../buttons/WarningButton/WarningButton.js');
require('../../buttons/AvatarButtons/ButtonWithAvatar/ButtonWithAvatar.js');
require('../../buttons/AvatarButtons/AvatarWithSubtitle/AvatarWithSubtitle.js');
require('../../buttons/AvatarButtons/VerticalAvatar/VerticalAvatar.js');
var styledComponents = require('./styled-components.js');

var DialogCancelAndConfirm = function (props) {
    var fm = reactIntl.useIntl().formatMessage;
    var cancelHandler = props.cancelHandler, confirmHandler = props.confirmHandler, _a = props.confirmTitle, confirmTitle = _a === void 0 ? fm({ id: 'componentLib.appWide.confirm' }) : _a, _b = props.disabledConfirm, disabledConfirm = _b === void 0 ? false : _b;
    return (React__default.createElement(styledComponents.ButtonContainer, null,
        React__default.createElement(DialogSecondaryButton, { onClick: cancelHandler, "data-testid": 'cancel-button' }, fm({ id: 'componentLib.appWide.cancel' })),
        React__default.createElement(DialogPrimaryButton, { disabled: disabledConfirm, onClick: confirmHandler, "data-testid": 'confirm-button' }, confirmTitle)));
};

module.exports = DialogCancelAndConfirm;
